export class IntlInstanceCache {
	dateTimeCache: any = {};
	numberCache: any = {};

	getDateTime = (
		locale: string,
		options: Intl.DateTimeFormatOptions = {},
	) => {
		const key = JSON.stringify([locale, options]);
		let intlInstance = this.dateTimeCache[key];

		if (!intlInstance) {
			intlInstance = new Intl.DateTimeFormat(locale, options);
			this.dateTimeCache[key] = intlInstance;
		}

		return intlInstance;
	}

	getNumber = (locale: string, options: Intl.NumberFormatOptions = {}) => {
		const key = JSON.stringify([locale, options]);
		let intlInstance = this.numberCache[key];

		if (!intlInstance) {
			intlInstance = new Intl.NumberFormat(locale, options);
			this.numberCache[key] = intlInstance;
		}

		return intlInstance;
	}
}

export default new IntlInstanceCache();
